import { AppRoutes } from './core/router/AppRoutes';

export const App = () => {
	return <AppRoutes />;
};
